// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#template-font-files-dropzone[data-v-8161a8ca]{min-height:126px}#template-font-files-add-files[data-v-8161a8ca]{padding-top:34px}.dz-uploaded-file[data-v-8161a8ca]{cursor:default}#template-font-files-add-more-files[data-v-8161a8ca]{position:absolute;left:15px;bottom:16px}.progress-display[data-v-8161a8ca]{position:absolute;left:15px;bottom:10px;width:calc(100% - 100px)}", ""]);
// Exports
module.exports = exports;
